const Data = [
    {
        name: "Nilesh Nagesh",
        position: "President",
        imageUrl: "/assets/images/members/NileshNagesh.png",
        facebookLink: "https://www.facebook.com/nilesh.nagesh.37?mibextid=ZbWKwL",
        email: 'nilesh.nagesh@gyws.org',
        linkedinLink: "https://www.linkedin.com/in/nilesh-nagesh-b1ba4a201?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        name: "K Nikhil Sathwik",
        position: "General Secretary",
        imageUrl: "/assets/images/members/GB23/K Nikhil Sathwik.jpg",
        facebookLink: "https://www.facebook.com/nikhil.sathwik.35",
        linkedinLink: "https://www.linkedin.com/in/kandregula-nikhil-sathwik-979a571b6/",
        email: "k.nikhil@gyws.org"
    },
    {
        name: "Priyam Goenka",
        position: "Vice President",
        imageUrl: "/assets/images/members/GB23/priyam goenka.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100011134831377",
        linkedinLink: "https://www.linkedin.com/in/priyam-goenka-221b371bb/",
        email: "priyam.goenka@gyws.org"
    },
    {
        name: "Vinay Siwach",
        position: "Assistant Secretary ",
        imageUrl: "/assets/images/members/GB23/Vinay Siwach.jpg",
        facebookLink: "https://www.facebook.com/vinay.siwach.142/",
        linkedinLink: "https://www.linkedin.com/in/vinaysiwach7/",
        email: "vinay.siwach@gyws.org"
    },
    {
        name: "Vageesh Tiwari",
        position: "Human Resource Manager",
        imageUrl: "/assets/images/members/GB23/Vageesh Tiwari.jpg",
        facebookLink: "https://www.facebook.com/vageesh.tiwari.712",
        linkedinLink: "https://www.linkedin.com/in/vageesh-tiwari-5940711b9/",
        email: "vageesh.tiwari@gyws.org"
    },
    {
        name: "Debasish Tudu",
        position: "Treasurer",
        imageUrl: "/assets/images/members/GB23/Debasish T.jpg",
        facebookLink: "https://www.facebook.com/debasish.tudu.102",
        linkedinLink: "https://www.linkedin.com/in/debasishtudufinance/", email: "debasish.tudu@gyws.org"
    },
    {
        name: "Mridula Mathukumalli",
        position: "School Development Officer ",
        imageUrl: "/assets/images/members/Mridula.JPG",
        facebookLink: "https://www.facebook.com/profile.php?id=100008744386729",
        linkedinLink: "https://www.linkedin.com/in/mridulasarma",
        email: "mridula.mathukumalli@gyws.org"
    },
    {
        name: "Rudransh Agrawal",
        position: "Chief Fundraising Officer",
        imageUrl: "/assets/images/members/GB23/Rudransh Agrawal.jpeg",
        facebookLink: "https://www.facebook.com/rudransh.agrawal.3",
        linkedinLink: "https://www.linkedin.com/in/rudransh-agrawal-57a136202/",
        email: "rudransh.agrawal@gyws.org"
    },
    {
        name: "Sayali Mahipal Ganvir",
        position: "Hostel Committee Officer",
        imageUrl: "/assets/images/members/MahipalGanvir.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100010676352813",
        linkedinLink: "https://www.linkedin.com/in/sayali-ganvir-160074206/",
        email: "sayali.mahipal@gyws.org"
    },
    {
        name: "Nikhil Lahane",
        position: "Chief Executive Officer, LiGHT",
        imageUrl: "/assets/images/members/NikhilLahane.jpg",
        facebookLink: "https://www.facebook.com/nikhil.lahane.143",
        linkedinLink: "https://www.linkedin.com/in/nikhil-lahane-4541641b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "nikhil.lahane@gyws.org"
    },
    {
        name: "Ankita",
        position: "Donor Engagement Officer",
        imageUrl: "/assets/images/members/AnkitaKhakhal.jpg",
        facebookLink: "https://www.facebook.com/ankita.khakhal?mibextid=JRoKGi",
        linkedinLink: "https://www.linkedin.com/in/ankita-khakhal-280946205",
        email: 'ankita@gyws.org'
    },
    {
        name: "Swastik Sambhav",
        position: "Chief Technical Officer",
        imageUrl: "/assets/images/members/SwastikSambhav.jpg",
        facebookLink: "https://www.facebook.com/swastik.sambhav.338",
        linkedinLink: "https://www.linkedin.com/in/swastik-sambhav-1622111b9/",
        email: "swastik.sambhav@gyws.org"
    },
    {
        name: "Nadimpalli Deepthi",
        position: "Public Relation Officer",
        imageUrl: "/assets/images/members/Deepthi.jpg",
        facebookLink: "https://www.facebook.com/deepthi.nadimpalli.39",
        linkedinLink: "https://www.linkedin.com/in/nadimpalli-deepthi-b9925821b/",
        email: "deepthi.nadimpalli@gyws.org"
    },
    {
        name: "Tanishq Agrawal",
        position: "Foreign and Corporate Relation Officer",
        imageUrl: "/assets/images/members/GB23/Tanishq Agrawal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100007165620906",
        linkedinLink: "https://www.linkedin.com/in/tanishq-agrawal-3921b5205/",
        email: "rudransh.agrawal@gyws.org"
    },

]

export default Data;